import { render, staticRenderFns } from "./pdf-view.vue?vue&type=template&id=faac7cc4&"
import script from "./pdf-view.vue?vue&type=script&lang=js&"
export * from "./pdf-view.vue?vue&type=script&lang=js&"
import style0 from "pdfjs-dist/web/pdf_viewer.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports